// ** react imports
import React, { useEffect, useMemo, useState } from 'react';

// ** components imports
import SectionHeader from './SectionHeader';
import QuestionItem from './QuestionItem';

// ** context imports
import { useQuiz } from '../../../../contexts/QuizContext';

const QuestionList = () => {
  const {
    activeSection,
    quizSections,
    sectionData,
    questions,
    isEditMode,
    handleEditQuiz,
    handleCancelEdit,
    isAddNotesLoading,
    isUpdateSectionAnswerByAdminLoading,
  } = useQuiz();

  const mergedQuestions = useMemo(() => {
    if (!questions || !Array.isArray(questions)) return [];
    const answers = Array.isArray(sectionData?.existingAnswers)
      ? sectionData.existingAnswers
      : [];
    if (!answers.length) return questions;
    return questions.map(q => ({
      ...q,
      ...(answers.find(a => a.questionId === q.questionId) || {}),
    }));
  }, [questions, sectionData]);

  if (!sectionData) {
    return (
      <div className="lg:col-span-3">
        <div className="text-center py-8">
          <svg
            className="w-12 h-12 text-gray-400 dark:text-gray-500 mx-auto mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
            />
          </svg>
          <p className="text-gray-500 dark:text-gray-400">
            No section data available
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="lg:col-span-3">
      <div>
        <SectionHeader
          section={quizSections[activeSection]}
          isEditing={isEditMode}
          onEdit={handleEditQuiz}
          onSave={handleEditQuiz}
          onCancel={handleCancelEdit}
          isSaving={isUpdateSectionAnswerByAdminLoading || isAddNotesLoading}
        />

        {/* Questions List */}
        <div className="max-h-[calc(70vh-100px)] overflow-y-auto rounded-lg space-y-4">
          {mergedQuestions && mergedQuestions.length > 0 ? (
            mergedQuestions.map(question => {
              return (
                <QuestionItem
                  question={question}
                  key={question.questionNumber}
                />
              );
            })
          ) : (
            <div className="text-center py-8">
              <svg
                className="w-12 h-12 text-gray-400 dark:text-gray-500 mx-auto mb-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                />
              </svg>
              <p className="text-gray-500 dark:text-gray-400">
                No questions available for this section
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuestionList;
